// Deep merge where plain objects merge recursively and arrays fully replace.
export function deepMerge(base, override) {
  if (override === undefined || override === null) return base;
  if (Array.isArray(override)) return override.slice();
  if (
    typeof override === "object" &&
    base &&
    typeof base === "object" &&
    !Array.isArray(base)
  ) {
    const out = { ...base };
    for (const k of Object.keys(override)) {
      out[k] = deepMerge(base[k], override[k]);
    }
    return out;
  }
  return override;
}
